// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KjXrB","col":"styles_col__19j_Y"};